import { Flex, FlexProps } from '@chakra-ui/react';

import { Info } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export interface ListWarningProps {
  warningText: string | React.JSX.Element;
  actionText?: string;
  actionOnClick?: () => void;
}

export const ListWarning: React.FC<ListWarningProps & FlexProps> = ({
  warningText,
  actionText,
  actionOnClick = () => {},
  ...props
}) => {
  const warningTextComp =
    typeof warningText === 'string' ? <TextBodyMedium>{warningText}</TextBodyMedium> : warningText;
  return (
    <Flex
      alignItems="center"
      gap={2}
      borderRadius="8px"
      borderWidth="1px"
      borderColor="neutral.EBEFF3"
      bgColor="neutral.FDFDFD"
      p="12px 8px"
      {...props}
    >
      <Info boxSize="24px" />
      {warningTextComp}
      {actionText && (
        <Button ml="auto" variant="tertiary" onClick={actionOnClick}>
          {actionText}
        </Button>
      )}
    </Flex>
  );
};
